module.exports = __webpack_public_path__ + "static/portfolio_gallery_9-a60db82b306e2a54a3ff2a6135dea10c.jpg";